export default function TermsAndPrivacyPolicy() {
  return (
    <div className="flex items-center justify-center">
      <p className="text-brown-dark w-80 text-center text-xs font-light">
        By continuing, you agree to Custody Navigator&apos;s{' '}
        <a href="https://legal.custodynavigator.com/terms" target="_blank" rel="noreferrer" className="underline">
          Terms of Service
        </a>{' '}
        and{' '}
        <a
          href="https://legal.custodynavigator.com/privacy-policy"
          target="_blank"
          rel="noreferrer"
          className="underline"
        >
          Privacy Policy
        </a>
        .
      </p>
    </div>
  );
}
